export const PDF_TYPES = [
	{ label: 'Sick leave', value: 'l4' },
	{ label: 'Paid vacation', value: 'paid_vacation' },
	{ label: 'Unpaid vacation', value: 'unpaid_vacation' },
	{ label: 'Special leave', value: 'special_leave' },
];
